import React from "react";
import { DataTable } from "../../../../";
import { Grid } from "@material-ui/core";
import { Link } from "react-router-dom";
import VisibilityIcon from "@material-ui/icons/Visibility";

var CampusSingleTabGroups = function CampusSingleTabGroups(props) {
  var auxTranslation = props.translation;

  if (auxTranslation && auxTranslation.datatables && auxTranslation.datatables.groups) {
    !auxTranslation.datatables.groups.columns.find(function (column) {
      return column.name === "options";
    }) ? auxTranslation.datatables.groups.columns.push({
      label: "",
      name: "options",
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        empty: true,
        label: false,
        customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
          return /*#__PURE__*/React.createElement(Link, {
            to: "/campus/".concat(props.campusId, "/groups/").concat(tableMeta.rowData[0]),
            style: {
              color: "#fafafa"
            }
          }, /*#__PURE__*/React.createElement(VisibilityIcon, null));
        }
      }
    }) : auxTranslation.datatables.groups.columns[auxTranslation.datatables.groups.columns.length - 1] = {
      label: "",
      name: "options",
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        empty: true,
        label: false,
        customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
          return /*#__PURE__*/React.createElement(Link, {
            to: "/campus/".concat(props.campusId, "/groups/").concat(tableMeta.rowData[0]),
            style: {
              color: "#fafafa"
            }
          }, /*#__PURE__*/React.createElement(VisibilityIcon, null));
        }
      }
    };
  }

  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(DataTable, {
    data: props.groups,
    translation: auxTranslation ? auxTranslation.datatables ? auxTranslation.datatables.groups || null : null : null
  }));
};

export { CampusSingleTabGroups };